module.exports = __webpack_public_path__ + "static/img/p1.50d7a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p1.png
// module id = h+Ta
// module chunks = 15